export default {
  locale: 'en',
  DatePicker: {
    chooseTime: 'Select time',
    chooseDate: 'Select date',
    Monday: 'Mon', TuesDay: 'Tues', Wednesday: 'Wed', ThursDay: 'Thur', Friday: 'Fri', Saturday: 'Sat', Sunday: 'Sun',
    MonthName: ' -',
    YearName: '',
    months: ['Jan', 'Feb', 'Mon', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  },
  Select: {
    notFoundContent: 'No Result Found'
  },
  Modal: {
    cancel: 'Cancel',
    ok: 'Confirm'
  },
  Page: {
    go: 'Go',
    per: '/page',
    page: 'page',
    total: 'Total',
    result: 'records',
    next: 'Next Page',
    first: 'First Page',
    last: 'Last Page',
    previous: 'Previous page',
    back: 'Back ward',
    to: 'Forward'
  }
};
